module.exports = __webpack_public_path__ + "static/img/businessSearchDetail.39fd07d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/businessSearchDetail.png
// module id = WnX5
// module chunks = 0